import React from "react";
import { Link } from "react-router-dom";

import logoLight from '../assets/images/logo-light.svg'

import { footerCompany, footerSocial } from "../data/data";
import {FiMail} from '../assets/icons/vander'

export default function Footer(){
    return(
        <footer className="footer bg-dark-footer relative text-gray-200 dark:text-gray-200">
            <div className="container relative">
                <div className="grid grid-cols-12">
                    <div className="col-span-12">
                        <div className="py-[60px] px-0">
                            <div className="grid md:grid-cols-12 grid-cols-1 gap-6">
                                <div className="lg:col-span-5 md:col-span-12">
                                    <Link to="/" className="text-[22px] focus:outline-none">
                                        <img src={logoLight} alt="Chile-Turismo.cl"/>
                                    </Link>
                                    <p className="mt-6 text-gray-300">¿Planeas un viaje? Organizamos tu experiencia con los mejores lugares y al mejor precio.</p>
                                    {footerSocial.length > 0 && (
                                        <ul className="list-none mt-6 space-x-1">
                                            {footerSocial.map((item,index)=>{
                                                let Icon = item.icon
                                                return(
                                                    <li className="inline" key={index}><Link to={item.link} target="_blank" rel="noopener noreferrer" aria-label={item.name || "Red social"} className="size-8 inline-flex items-center justify-center tracking-wide align-middle text-base border border-gray-800 dark:border-slate-800 rounded-md hover:bg-red-500 hover:text-white text-slate-300"><Icon className="size-4 align-middle" aria-hidden="true"></Icon></Link></li>
                                                )
                                            })}
                                        </ul>
                                    )}
                                </div>

                                <div className="lg:col-span-4 md:col-span-6">
                                    <div className="lg:ms-8">
                                        <h5 className="tracking-[1px] text-gray-100 font-semibold">Contacto</h5>
                                        <h5 className="tracking-[1px] text-gray-100 mt-6">Chile-Turismo.cl</h5>

                                        <div className="flex mt-4">
                                            <FiMail className="size-4 text-red-500 me-2 mt-1"></FiMail>
                                            <div className="">
                                                <a href="mailto:turismo@cmsystem.cl" className="text-slate-300 hover:text-slate-400 duration-500 ease-in-out">turismo@cmsystem.cl</a>
                                            </div>
                                        </div>
                                        {/* TODO negocio: teléfono/dirección reales */}
                                    </div>
                                </div>

                                <div className="lg:col-span-3 md:col-span-6">
                                    <div className="lg:ms-8">
                                        <h5 className="tracking-[1px] text-gray-100 font-semibold">Compañía</h5>
                                        <ul className="list-none footer-list mt-6">
                                            {footerCompany.map((item,index)=>{
                                                return(
                                                    <li className="mt-[10px] first:mt-0" key={index}><Link to={item.link} className="text-gray-300 hover:text-gray-400 duration-500 ease-in-out"><i className="mdi mdi-chevron-right"></i> {item.name}</Link></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-[30px] px-0 border-t border-slate-800">
                <div className="container relative text-center">
                    <div className="grid grid-cols-1">
                        <div className="text-center">
                            <p className="mb-0">© {new Date().getFullYear()} Chile-Turismo.cl</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
